import Common from '../common/CommonPowerbook';
import Table from './TmplTable';
import ChainTable from './TmplChainTable';
import ListType from './TmplListType';
import TableOfContents from './TableOfContents';
import ObjWeapon from './TmplObjectWeapon';
import ObjArmor from './TmplObjectArmor';
import ObjItem from './TmplObjectItem';
import ObjAcc from './TmplObjectAccessories';
import ObjMagic from './TmplObjectMagic';
import ObjMonster from './TmplObjectMonster';
import ObjNPC from './TmplObjectNPC';
import ObjMagicGoods from './TmplObjectMagicGoods';
import ObjQuest from './TmplObjectQuest';
import ObjMaking from './TmplObjectMaking';
import ObjSet from './TmplObjectSet';

let listType = {};
let objectType = {};

class Tmpl {
    constructor(){
        listType = new ListType();

        objectType = {
            "무기" : new ObjWeapon(),
            "방어구" : new ObjArmor(),
            "일반 아이템" : new ObjItem(),
            "액세서리" : new ObjAcc(),
            "마법" : new ObjMagic(),
            "몬스터" : new ObjMonster(),
            "NPC" : new ObjNPC(),
            "마법용품" : new ObjMagicGoods(),
            "퀘스트" : new ObjQuest(),
            "제작" : new ObjMaking(),
            "세트" : new ObjSet()
        };

        this.TableOfContents = new TableOfContents();
        this.com = Common.instance;
    }

    make(_d){
        let upDateDay = '';
        if (_d.last_update) {
            let da = new Date(_d.last_update.replace(/-/gi, "/"));
            upDateDay = `${da.getFullYear()}.${ this.com.leadingZeros(da.getMonth()+1, 2)}.${ this.com.leadingZeros(da.getDate(), 2)}.`;
        }
        return `
<div class="section-wiki">
    <div class="wiki__h1">
        <h1>${_d.title}</h1>
        ${upDateDay?`<div class="inform_area">이 문서는 <em>${upDateDay}</em>에 업데이트 되었습니다. <br>일부 내용은 게임과 다를 수 있으며 자세한 내용은 <em><a href="/board/update/list">업데이트 공지</a></em>를 참고 부탁 드립니다.</div>`:``}
    </div>
    ${_d.bodys.map( (item, idx) => this.section(item, idx, _d) ).join('\n ')}
    ${(new ChainTable()).make(_d.chain_table)}
</div>`;
    }


    section(_d, _idx, _allD){
        return `
<div class="wiki__group" id="${_allD.no}-${_idx}">
    ${(_d.header)? `<div class="wiki__h2"><h2>${_d.header}</h2></div>`: ''}
    <div class="wiki__body">
        ${this.sectionBodySelect(_d)}
        ${this.TableOfContents.make(_allD, _idx)}
    </div>
</div>`;
    }

    sectionBodySelect(_d){
        let list = _d.paragraphs.map( item => {

            if(item.type == 'html') return item.body;

            if(item.tag == '객체 불러오기') return objectType[item.object_type].make(item.object);

            if(item.tag == '목록 불러오기') return listType.make(item);

            if(item.tag == '표 불러오기') return Table.make(item.object);

            return item.tag +' : '+ item.object_type;
        } ).join('\n ');


        // 인게임 외부링크 제거
        if(!this.com.isIngame){
            return list;
        } else {
            return list.replace(/href="(http[^"]+)"/gim, ( origin, match ) => {
                return (/lineage\.plaync\.com\/powerbook\/wiki\//.test(match))? origin: '';
            });
        } 
    }

}


export default Tmpl;


// WEBPACK FOOTER //
// ./lineage/Tmpl.js